import { Clock, FileText, Package, User } from 'lucide-react'

import { useScanProgressState } from '../stores/scanProgressStore'

const ScanRecord: React.FC = () => {
  const { loading, recordList } = useScanProgressState()

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-3">
      {/* 标题 */}
      <div className="flex items-center gap-2 mb-3 border-b border-gray-100 pb-2">
        <FileText className="w-4 h-4 text-gray-600" />
        <span className="text-sm font-medium text-gray-800">最近扫描</span>
        {recordList.length > 0 && (
          <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">
            {recordList.length}
          </span>
        )}
      </div>

      {/* 记录列表 */}
      <div className="h-full overflow-y-auto">
        {loading ? (
          <div className="text-center py-6">
            <Clock className="w-6 h-6 text-gray-300 mx-auto mb-2" />
            <div className="text-gray-500 text-xs">加载中...</div>
          </div>
        ) : recordList.length === 0 ? (
          <div className="text-center py-6">
            <div className="text-gray-400 text-xs">暂无扫描记录</div>
          </div>
        ) : (
          <div className="space-y-2">
            {recordList.slice(0, 5).map((record) => (
              <div
                key={record.updatedAt}
                className="flex items-center justify-between p-2 bg-gray-50 hover:bg-blue-50 rounded border border-transparent hover:border-blue-200 transition-all duration-150"
              >
                <div className="flex items-center flex-1 min-w-0">
                  <Package className="w-3 h-3 text-blue-500 flex-shrink-0 mr-2" />
                  <span className="text-xs font-medium text-gray-800 w-20 truncate">
                    {record.barcode}
                  </span>
                  <div className="flex-1 border-b border-dotted border-gray-300 mx-2"></div>
                  <span className="text-primary-700 px-1.5 py-0.5 rounded text-xs font-medium flex-shrink-0 min-w-8 text-center mr-2">
                    {record.scannedCount}
                  </span>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0 text-xs min-w-28">
                  <div className="flex items-center gap-1 text-gray-500 w-20">
                    <User className="w-3 h-3 flex-shrink-0" />
                    <span className="truncate text-xs">
                      {record.operatorName}
                    </span>
                  </div>
                  <div className="flex items-center gap-1 text-gray-400 w-12 justify-end">
                    <Clock className="w-3 h-3 flex-shrink-0" />
                    <span className="text-xs">
                      {new Date(record.createdAt).toLocaleTimeString('zh-CN', {
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </span>
                  </div>
                </div>
              </div>
            ))}
            {recordList.length > 5 && (
              <div className="text-center pt-1">
                <span className="text-xs text-gray-400">
                  还有 {recordList.length - 5} 条记录...
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default ScanRecord
